import { render, staticRenderFns } from "./AccountPlugins.vue?vue&type=template&id=11d1743c&scoped=true&"
import script from "./AccountPlugins.vue?vue&type=script&lang=js&"
export * from "./AccountPlugins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d1743c",
  null
  
)

export default component.exports